var ServiceErrors = (function () {
    function ServiceErrors() {
        this.errors = [];
        this.errorCodes = [];
    }
    ServiceErrors.prototype.hasErrors = function () {
        if (this.raw) {
            return true;
        }
        else if (this.errors && this.errors.length > 0) {
            return true;
        }
        else if (this.errorCodes && this.errorCodes.length > 0) {
            return true;
        }
        else {
            return false;
        }
    };
    ServiceErrors.prototype.isSessionExpired = function () {
        if (!this.errorCodes)
            return false;
        return this.errorCodes.some(function (value) {
            return value === 1;
        });
    };
    return ServiceErrors;
}());
export default ServiceErrors;



//////////////////
// WEBPACK FOOTER
// ./src/modules/services/models/ServiceErrors.ts
// module id = null
// module chunks = 